module.exports = __webpack_public_path__ + "img/screenshot_n_22.12cee5b0.png";